import { Endpoint } from "../../typings/endpoints";
import { Instructor } from "../../typings/Instructor";
import http from "../../utils/http";

const instructorsApi = {
  getInstructors: async (): Promise<Instructor[]> => {
    const response = await http.get<Instructor[]>(Endpoint.InstructorList);
    return response.data;

  },
};

export default instructorsApi;
